var index = (function (fn) {
	return new Promise(function (resolve) {
		resolve(fn());
	});
});

export default index;
